import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-input-number-arrow",
  "use": "icon-input-number-arrow-usage",
  "viewBox": "0 0 24 12",
  "content": "<symbol viewBox=\"0 0 24 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-input-number-arrow\">\n    <path d=\"M16 8L12 4L8 8\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol